const localState = {
    masks: ['+##########', '+###########', '+#############', '+##############'],
    data: {},
    serverErrors: {},
    appeal: ['Herr', 'Frau', 'Direktor', 'Professor', 'Professorin'],
    theme: localStorage.getItem('theme') || 'dark',
    isTalkdeskCalling: false,
    talkdeskCaller: {
        client: {},
    },
    infoRootLink: '',
    infoLink: '',
}

const actions = {
    async addApplication({
        dispatch,
    }, {
        data,
        media,
    }) {
        try {
            const response = await this.$api.orders.create(data)

            media.forEach((element) => {
                dispatch('addApplicationMedia', {
                    id: response.data.id,
                    media: element,
                })
            })

            return response
        } catch (err) {
            console.log(err)
        }
    },
    async addApplicationMedia(_, {
        id,
        media,
    }) {
        try {
            await this.$api.orders.addMediaToOrders(id, media)
        } catch (err) {
            console.log(err)
        }
    },
}

const mutations = {
    setServerErrors: (state, v) => {
        state.serverErrors = v
    },
    setTheme: (state, v) => {
        state.theme = v
        localStorage.setItem('theme', v)
    },
    setTalkdesk: (state, v) => {
        state.isTalkdeskCalling = v
    },
    setTalkdeskCaller: (state, v) => {
        state.talkdeskCaller = v
    },
    setLink: (state, {
        key,
        value,
    }) => {
        state[key] = value
    },
}

const getters = {
    getServerErrors: (state) => state.serverErrors,
    masksGetters: (state) => state.masks,
    appealGetters: (state) => state.appeal,
    activeTheme: (state) => state.theme,
    isDark: (state) => state.theme === 'dark',
    isTalkdeskCalling: (state) => state.isTalkdeskCalling,
    talkdeskCaller: (state) => state.talkdeskCaller,
    infoLink: (state) => state.infoLink,
    infoRootLink: (state) => state.infoRootLink,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
